import { Tabs, TabsContent } from "@workspace/frontend-ui";
import { type FC, useEffect } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import type { RewardCenterTab } from "../../types";
import Celebration from "../Celebration";
import Faq from "../Faq";
import History from "../History";
import RewardCenterHeader from "./RewardCenterHeader";
import RewardCenterTabs from "./RewardCenterTabs";
import RewardsView from "./RewardsView";

type Props = {
  layout?: "popover" | "sheet";
};

const RewardCenter: FC<Props> = ({ layout = "popover" }) => {
  const {
    state: { tab },
    send,
  } = useRewardCenter();

  useEffect(() => send("backend", { type: "loadFrontData" }), [send]);

  const handleTabChange = (value: string) =>
    send("rewardCenter", {
      type: "selectTab",
      tab: value as RewardCenterTab,
    });

  return (
    <div
      data-slot="reward-center-sheet"
      className="relative flex min-h-0 flex-1 flex-col gap-2.5"
    >
      <RewardCenterHeader layout={layout} />
      <Tabs
        value={tab ?? "rewards"}
        onValueChange={handleTabChange}
        className="min-h-0 flex-1 gap-2.5"
      >
        <RewardCenterTabs />
        <div className="rc-scroll-none flex min-h-0 flex-1 flex-col overflow-y-auto">
          <TabsContent value="rewards" className="flex flex-col">
            <RewardsView />
          </TabsContent>
          <TabsContent value="history">
            <History />
          </TabsContent>
          <TabsContent value="faq">
            <Faq />
          </TabsContent>
        </div>
      </Tabs>
      <Celebration />
    </div>
  );
};

export default RewardCenter;
